import { all, call, put, takeLatest } from "redux-saga/effects";
import { adminAPI } from "../api/api";
import {
  adminDashboardActionTypes,
  adminDashboardActions,
} from "../store/reducers/adminDashboardReducer";
import { generalActions } from "../store/reducers/generalReducer";

function* getStats(): Generator<any, void, any> {
  try {
    const response: any = yield call(adminAPI.getDashboardStats);
    if (response.status === 200) {
      yield put(adminDashboardActions.getStatsSuccess(response.data));
    }
  } catch (error: any) {
    const message = error.response?.data?.message || "Failed to load dashboard stats";
    yield put(adminDashboardActions.getStatsError(message));
    yield put(generalActions.errorAC({ message, type: "error" }));
  }
}

function* refreshStats(): Generator<any, void, any> {
  try {
    const response: any = yield call(adminAPI.refreshDashboardStats);
    if (response.status === 200) {
      yield put(adminDashboardActions.refreshStatsSuccess(response.data));
      yield put(generalActions.successAC({ message: "Dashboard stats refreshed", type: "success" }));
    }
  } catch (error: any) {
    const message = error.response?.data?.message || "Failed to refresh dashboard stats";
    yield put(adminDashboardActions.refreshStatsError(message));
    yield put(generalActions.errorAC({ message, type: "error" }));
  }
}

export function* adminDashboardWatcher() {
  yield all([
    takeLatest(adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS, getStats),
    takeLatest(adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS, refreshStats),
  ]);
}
